import { Titled } from 'react-titled';
import type { FC } from 'react';
import TikTokFormProvider from 'features/tiktok/components/TikTokFormProvider';

const TikTokPage: FC = () => (
  <>
    <Titled title={(title) => `WellTech User Acquisition | ${title}`} />
    <TikTokFormProvider />
  </>
);

export default TikTokPage;
